import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  useTheme,
  Box,
  Link,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link as RouterLink } from 'react-router-dom';

import { useToggle, useColumnView } from 'hooks';
import ColumnView from 'ui/ColumnView';
import { ComputedRoute } from 'utils/ComputedRoute';
import { IHierarchyLevel } from 'api/catalog/models';
import StyledSideBadge from 'ui/StyledSideBadge';
import { toTitleCase } from 'utils/toTitleCase';

interface IProps {
  hierarchy: IHierarchyLevel;
  isOpen?: boolean;
}

const HierarchyListing = ({ hierarchy, isOpen }: IProps) => {
  const theme = useTheme();
  const items = useColumnView(hierarchy.children);
  const { val: isSectionOpen, toggle: toggleIsSectionOpen } = useToggle(isOpen);
  return (
    <Accordion
      TransitionProps={{ unmountOnExit: true }}
      disableGutters
      expanded={isSectionOpen}
      onChange={toggleIsSectionOpen}
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        '&:not(:last-child)': {
          borderBottom: 0,
        },
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        sx={{
          backgroundColor: theme.palette.grey[200],
          color: theme.palette.common.black,
        }}
        expandIcon={
          <ExpandMoreIcon sx={{ color: theme.palette.common.black }} />
        }
      >
        <Typography>{hierarchy.name}</Typography>
        <StyledSideBadge
          color='primary'
          badgeContent={hierarchy.children ? hierarchy.children.length : 0}
        />
      </AccordionSummary>
      <AccordionDetails>
        <ColumnView>
          {items.map((group, index) => (
            <Box width={`${100 / items.length - 1}%`} key={index}>
              <ul style={{ margin: '0px', padding: '0px 0px 0px 20px' }}>
                {group.map((item) => (
                  <li
                    style={{ color: theme.palette.primary.main }}
                    key={item.name}
                  >
                    <Link
                      component={RouterLink}
                      to={ComputedRoute.getSearchRoute({
                        categoryNames: [item.name],
                      })}
                    >
                      {toTitleCase(item.name)}
                    </Link>
                  </li>
                ))}
              </ul>
            </Box>
          ))}
        </ColumnView>
      </AccordionDetails>
    </Accordion>
  );
};

export default HierarchyListing;
